import PropTypes from 'prop-types'
import { Link, useLocation } from 'react-router-dom'
import classNames from 'classnames'

const ToolboxNaviLink = ({ to, children, iconSrc }) => {
  const { pathname } = useLocation()
  return (
    <li className={classNames({ on: pathname === to })}>
      <Link to={to} className="link_sub">
        <img src={iconSrc} alt="" className="img_g" />
        <span className="txt_sub">{children}</span>
      </Link>
    </li>
  )
}

ToolboxNaviLink.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  iconSrc: PropTypes.string.isRequired,
}

export default ToolboxNaviLink
